import { colors } from '../../Colors/colors'

export const aiChatSupport = {
   light: {
      common: {
         defaultTextColor: 'text-gray-900',
         defaultBorderColor: 'border-gray-300',
         defaultBgColor: 'bg-gray-100',
         baseBgColor: 'bg-base-white',
         refreshHandlerBGColor: '!bg-white',
         primaryIconColor: colors['primary-600']
      },
      chatSupport: {
         bodyBgColor: 'bg-gray-25'
      },
      chatBox: {
         headerTextColor: 'text-gray-700',
         descriptionTextColor: 'text-gray-600',
         xCloseIconColor: colors['gray-500'],
         chatBoxTextField: {
            chatBoxTextColor: '!text-gray-700',
            defaultBgColor: 'bg-base-white',
            descriptionTextColor: 'text-gray-500',
            descriptionLinkTextUnderLineColor: 'decoration-gray-500',
            inputFocusedBorderColor: 'border-primary-600',
            inputBorderColor: 'border-gray-300',
            iconButtonBgColor: '!bg-gray-50',
            sendIconButtonColor:
               'bg-[linear-gradient(90deg,_#1570EF_0%,_#2E90FA_100%)]',
            sendIconColor: colors['gray-500']
         },
         chatHistoryCard: {
            headerTextColor: 'text-gray-600',
            historyTitleColor: 'text-gray-800',
            historyDateTimeTextColor: 'text-gray-500'
         },
         chatVirtualAssistantIconColor: colors['blue-light-200'],
         historyIconColor: colors['gray-400'],
         chatHistoryBorderColor: 'border-gray-200'
      },
      userQueriedChatBox: {
         cardBorderColor: 'border-gray-300',
         activeCardBorderColor: 'border-primary-600',
         dotBgColor: 'bg-gray-300',
         nameTextColor: 'text-gray-600',
         timeTextColor: 'text-gray-400',
         editButtonTextColor: 'text-gray-700',
         userSearchQueryTextColor: '!text-gray-700',
         defaultBgColor: 'bg-base-white',
         messageContentTextColor: 'text-gray-700',
         userIconFillColor: colors['gray-600'],
         questionBorderColor: 'border-gray-200',
         questionBGColor: 'bg-gray-50'
      },
      sqlQueryCard: {
         clausesTextColor: 'text-primary-600',
         operatorsTextColor: 'text-orange-600',
         defaultTextColor: 'text-gray-600',
         normalTextColor: 'text-teal-600',
         sqlQueryBgColor: 'bg-gray-50'
      },
      chatSupportHistoryPopover: {
         refreshIconColor: colors['gray-600'],
         popoverCardBorderColor: 'border-gray-300',
         historyItemHoverColor: 'hover:bg-gray-50',
         historyTextColor: 'text-gray-700',
         historyItemTextColor: 'text-gray-900',
         defaultBgColor: 'bg-base-white'
      },
      goToTop: {
         buttonBgColor: 'bg-gray-800',
         buttonHoverColor: 'hover:bg-gray-900'
      },
      threadDetailedView: {
         threadTitleColor: 'text-gray-700',
         historyIconColor: colors['gray-400'],
         plusIconColor: colors['gray-400']
      },
      aiActionCenter: {
         closeIconBgColor: 'bg-blue-light-800',
         closeIconFillColor: colors['base-white'],
         chatBoxCloseIconFillColor: colors['gray-400'],
         defaultBorderColor: 'border-gray-300',
         cardBgColor: 'bg-base-white',
         optionTextColor: 'text-gray-600',
         headerTextColor: 'text-gray-700',
         pillBgColor: 'bg-gray-300',
         menuIconColor: colors['gray-400'],
         menuOptionHoverColor: 'hover:bg-gray-50',
         menuOptionTextColor: 'text-gray-900',
         menuOptionIconColor: colors['gray-600'],
         backIconColor: colors['gray-600'],
         plusIconColor: colors['gray-400'],
         chatHistoryHeadingTextColor: 'text-gray-700',
         chatHistoryIconColor: colors['gray-500'],
         chatHistoryCardTextColor: 'text-gray-600',
         searchIconColor: colors['gray-600'],
         chevronLeftDoubleIconColor: colors['gray-400'],
         iconBgColor: 'bg-primary-200'
      }
   },
   dark: {}
}
